import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "love-it-modal-header",
    templateUrl: "./modal-header.component.html",
    styleUrls: ["./modal-header.component.scss"],
    standalone: false
})
export class ModalHeaderComponent {
  @Input() title: string;
  @Output() close = new EventEmitter<void>();
}
